export default "https://cdn-static.gokick.com/assets/f85860d356d81c773b535a0002382fa42e6b6edf/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";